var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDisconnectSessionOrangeIcon = function SvgDisconnectSessionOrangeIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#FD7F38",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M3 7.5v-1a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2h-4M2 21l8-8M10 21l-8-8"
  })));
};
export { SvgDisconnectSessionOrangeIcon as ReactComponent };
export default __webpack_public_path__ + "b9a36ccae609f30ef4fc9f2549841913.svg";